
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { OilRequirements } from "~/types/OilRequirement";
import EnergyLegend from "~/components/organisms/display/EnergyLegend.vue";
import PelletsTable from "~/components/organisms/table/PelletsTable.vue";
import Footnotes from "~/components/organisms/text/Footnotes.vue";
import PelletsStatistics from "~/components/organisms/display/geographySites/PelletsStatistics.vue";

@Component({
  components: {
    PelletsTable,
    Footnotes,
    EnergyLegend,
    PelletsStatistics,
  },
})
export default class EnergyCalculator extends Vue {
  @Prop() city!: string;
  @Prop() zipcode!: string;
  @Prop() requirements!: OilRequirements;
}
